import createIsValid from './selectors/isValid';
import plain from './structure/plain';

export default createIsValid(plain);


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/es/isValid.js
// module id = 1082
// module chunks = 0